var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-section',{attrs:{"title":"趋势图"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_c('div',{staticClass:"blood-oxygen-chart",style:(`width: 970px; height: ${200 * _vm.zoom}px ;zoom:${
          1 / _vm.zoom
        };transform:scale(${_vm.zoom});transform-origin:0 0`),attrs:{"id":_vm.bloodOxygenTitle}}),_c('div',{staticClass:"pulse-chart",style:(`width: 970px; height: ${220 * _vm.zoom}px ;zoom:${
          1 / _vm.zoom
        };transform:scale(${_vm.zoom});transform-origin:0 0; margin-top: 20px`),attrs:{"id":_vm.pulseTitle}})])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }